import { Button, Checkbox, Col, ControlLabel, Row } from "react-bootstrap";
import { handleFieldChange, handleGroupByChange, JSONH } from "../../Utils";
import { PARAMS_NAME } from "../BidderV2/config";

import React from 'react';

import SelectWrap from "../../components/SelectWrap";
import FieldGroup from "../../components/FieldGroup";
import Container from "../../components/Container";
import Heading from "../../components/Heading";
import Graph from "./components/Graph";
import Table from '../../components/StatsTable';

import API from "../../services/API";

import moment from "moment";

class BidderClickUrls extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            graph: [],
            report: {
                headers: [],
                data: [],
                total: {},
            },
            values: {
                plugin: [],
            },
            filters: {
                plugin: [],
                dateFrom: undefined,
                dateTo: undefined,
            },
            realtime: false,
            group_by: [],
        }

        this.handleGroupByChange = handleGroupByChange.bind(this);
        this.handleFieldChange = handleFieldChange.bind(this);
        this.on_load = this.on_load.bind(this);
    }

    componentDidMount() {
        (async () => {
            const state = this.state;

            const values = await Promise.all([
                API.BidderPluginReport.distinct('plugin'),
                API.BidderPluginReport.get({ timestamp_gt: moment.utc().startOf('day').unix(), timestamp_lt: moment.utc().endOf('day').unix() }, [ 'timestamp' ]),
            ])

            state.values.plugin = values[0];

            state.graph = JSONH.decode(values[1]);

            state.loading = false;

            this.setState(state);
        })()
    }

    async on_load() {
        if (!this.state.group_by.length) return alert('Please select at least one group_by param');

        this.setState({ ...this.state, loading: true });

        const state = this.state;

        state.report = await API.BidderPluginReport.get(state.filters, state.group_by, state.realtime);

        state.graph = JSONH.decode(await API.BidderPluginReport.get(state.filters, [ 'timestamp' ], state.realtime));

        state.loading = false;

        this.setState(state);
    }

    render() {
        return (
            <Container loading={this.state.loading}>
                <Heading title="Bidder Plugin Report"/>

                <Row>
                    <Col lg={12}>
                        <ControlLabel>Group By:</ControlLabel>

                        <Checkbox onChange={this.handleGroupByChange} name="timestamp">Datetime</Checkbox>
                        <Checkbox onChange={this.handleGroupByChange} name="plugin">Plugin</Checkbox>
                        <Checkbox onChange={(event) => this.setState({ ...this.state, realtime: event.target.checked })} name="realtime">Realtime</Checkbox>
                    </Col>
                </Row>

                <Row>
                    <Col lg={4}>
                        <FieldGroup
                            type="date"
                            name="filters.timestamp_gt"
                            label="Date From:"
                            onChange={this.handleFieldChange}
                            timestamp={"true"}
                        />
                    </Col>

                    <Col lg={4}>
                        <FieldGroup
                            type="date"
                            name="filters.timestamp_lt"
                            label="Date To:"
                            onChange={this.handleFieldChange}
                            timestamp={"true"}
                        />
                    </Col>
                </Row>

                <Row>
                    <Col lg={3}>
                        <SelectWrap
                            values={this.state.values.plugin}
                            label="Plugin:"
                            name="filters.plugin"
                            onChange={this.handleFieldChange}
                            value={this.state.filters.plugin}
                            multi
                        />
                    </Col>
                </Row>

                <Row style={{ marginBottom: '15px' }}>
                    <Col lg={12}>
                        <Button bsStyle="primary" onClick={this.on_load}>Load</Button>
                    </Col>
                </Row>

                <Graph data={this.state.graph} />

                <Table
                    params={this.state.report.headers}
                    paramsObj={this.state.report.headers.reduce((object, header) => (object[header] = 1, object), {})}
                    report={this.state.report.data}
                    total={this.state.report.total}
                    paramNames={PARAMS_NAME}
                    unixParams={{ timestamp: 1 }}
                    NaNParams={{ plugin: 1 }}
                />
            </Container>
        )
    }
}

export default BidderClickUrls;



// WEBPACK FOOTER //
// ./src/scenes/BidderPluginReport/index.js